import { render } from "./base-select.vue?vue&type=template&id=ca2fe4e0&scoped=true"
import script from "./base-select.vue?vue&type=script&lang=js"
export * from "./base-select.vue?vue&type=script&lang=js"

import "./base-select.vue?vue&type=style&index=0&id=ca2fe4e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca2fe4e0"]])

export default __exports__